import { render, staticRenderFns } from "./ModalConfirmacaoMfa.vue?vue&type=template&id=2efc8991&scoped=true"
import script from "./ModalConfirmacaoMfa.vue?vue&type=script&lang=js"
export * from "./ModalConfirmacaoMfa.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmacaoMfa.vue?vue&type=style&index=0&id=2efc8991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efc8991",
  null
  
)

export default component.exports